export enum PreferredFreelancerBadgeType {
  PREFERRED_FREELANCER = 'preferred-freelancer.svg',
}
